import React, { useContext } from 'react';
import { Button, Toolbar } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useUserRolePermissions } from 'hooks';
import { func } from 'prop-types';
import { DrawerContext } from 'common/drawer/DrawerContext';
import { DRAWER_TYPES } from 'utils/constants';
import OneToOneReconsignment from '../reconsignmentsDrawer/OneToOneDrawer';

const MobileNav = ({ setIsFiltersOpen }) => {
  const { isProductOwnerManage, isInventoryOwner } = useUserRolePermissions();
  const { setDrawerComponentProps } = useContext(DrawerContext);

  return (
    <Toolbar
      disableGutters
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 1,
        position: 'fixed',
        top: 56,
        width: '100%',
        zIndex: 2,
      }}
      variant="dense"
    >
      {isProductOwnerManage && isInventoryOwner && (
        <Button
          onClick={() =>
            setDrawerComponentProps({
              Component: props => <OneToOneReconsignment {...props} />,
              type: DRAWER_TYPES.createReconsignment,
            })
          }
          startIcon={
            <AddRoundedIcon
              sx={{
                '& >*:nth-of-type(1)': {
                  fontSize: 24,
                },
                margin: 0,
              }}
            />
          }
          sx={{
            ':hover': {
              boxShadow: 'none',
            },
            borderRadius: 'unset',
            boxShadow: 'none',
            flex: 1,
            fontFamily: 'Gothic A1',
            fontSize: 16,
            height: 56,
            letterSpacing: 0.5,
            padding: theme => theme.spacing(0, 2),
          }}
        >
          Add New
        </Button>
      )}
      <Button
        endIcon={
          <ChevronRightRoundedIcon
            sx={{
              '& >*:nth-of-type(1)': {
                fontSize: 24,
              },
              margin: 0,
            }}
          />
        }
        onClick={() => setIsFiltersOpen(true)}
        sx={{
          ':hover': {
            backgroundColor: 'surface.white',
            boxShadow: 'none',
            color: 'secondary.main',
          },
          backgroundColor: 'surface.white',
          borderRadius: 'unset',
          boxShadow: 'none',
          color: 'secondary.main',
          flex: 1,
          fontFamily: 'Gothic A1',
          fontSize: 16,
          height: 56,
          letterSpacing: 0.5,
          padding: theme => theme.spacing(0, 2),
        }}
      >
        Filters
      </Button>
    </Toolbar>
  );
};

MobileNav.propTypes = {
  setIsFiltersOpen: func.isRequired,
};

export default MobileNav;
